import React, { Fragment, useState, useEffect } from "react";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import PageTitle from "../Layout/PageTitle";
import {
  Row,
  Col,
  Card,
  FormGroup,
  Form,
  Button,
  Spinner,
  Modal,
} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import axios from "axios";
import Swal from "sweetalert2";
import paginationFactory from "react-bootstrap-table2-paginator";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
// import * as SecureLS from "secure-ls";

function Content() {
  const server = window.$linkserver;
  const [dataTable, setdataTable] = useState([]);

  const [isLoadingmanodeobraCreada, setisLoadingmanodeobraCreada] = useState(
    "invisible"
  );
  const [isLoadingTable, setisLoadingTable] = useState("invisible");
  const [isLoadingActualizar] = useState("invisible");
  const [showModal, setshowModal] = useState(false);

  // const ls = new SecureLS({
  //   encodingType: "des",
  //   isCompression: false,
  //   encryptionSecret: "admin-hyundai",
  // });
  // const { infoUsuario } = ls.get("ask-hy");
  // const { data } = infoUsuario;

  const [manodeobra, setmanodeobra] = useState({
    mo_id: 0,
    mo_nombre: "",
    mo_descripcion: "",
    mo_precio: "",
  });

  const [error, seterror] = useState({
    mo_nombre: "",
    mo_descripcion: "",
    mo_precio: "",
  });

  const columns = [
    {
      dataField: "mo_id",
      text: "Codigo",
      sort: true,
    },
    {
      dataField: "mo_nombre",
      text: "Nombre",
      sort: true,
    },
    {
      dataField: "mo_descripcion",
      text: "Descripción",
      sort: true,
    },

    {
      dataField: "mo_precio",
      text: "Precio",
      sort: true,
    },
    {
      dataField: "mo_editar",
      text: "Editar",
      formatter: (cell, row, index) => editRow(row, index),
      sort: true,
    },
  ];

  const editRow = (row, index) => {
    return (
      <Button
        onClick={() => {
          edit(row, index);
        }}
        color="primary"
        variant="contained"
      >
        <FontAwesomeIcon icon={faEdit} />
      </Button>
    );
  };

  const edit = (row, index) => {
    setmanodeobra((manodeobra) => {
      return {
        ...manodeobra,
        mo_id: row.mo_id,
        mo_nombre: row.mo_nombre,
        mo_descripcion: row.mo_descripcion,
        mo_precio: row.mo_precio,
      };
    });

    setshowModal(true);
  };

  const getmanodeobras = async () => {
    setisLoadingTable("visible");
    await axios
      .get(server + "taller/getManoObra")
      .then(function (response) {
        setisLoadingTable("invisible");
        setdataTable(response.data);
      })
      .catch(function (error) {
        setisLoadingTable("invisible");
      })
      .then(function () {});
  };

  const showMessage = (msn, type) => {
    Toast.fire({
      title: msn,
      // text: msn,
      icon: type,
      confirmButtonText: "Entendido",
    });
  };

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
  });

  const createmanodeobra = async () => {
    seterror((error) => {
      return {
        ...error,
        mo_nombre: "",
        mo_descripcion: "",
        mo_precio: "",
      };
    });

    if (
      manodeobra.mo_nombre !== "" &&
      manodeobra.mo_descripcion !== "" &&
      manodeobra.mo_precio !== ""
    ) {
      setisLoadingmanodeobraCreada("visible");
      await axios

        .post(server + "taller/createmanoobra", {
          mo_nombre: manodeobra.mo_nombre,
          mo_descripcion: manodeobra.mo_descripcion,
          mo_precio: parseFloat(manodeobra.mo_precio),
        })

        .then(function (response) {
          setisLoadingmanodeobraCreada("invisible");

          if (response.status === 200) {
            showMessage("Mano de Obra creada con éxito", "success");

            setmanodeobra((manodeobra) => {
              return {
                ...manodeobra,
                mo_id: 0,
                mo_nombre: "",
                mo_descripcion: "",
                mo_precio: "",
              };
            });

            getmanodeobras();

            //getData()
          } else {
            showMessage("Error el crear", "error");
          }
        })
        .catch(function (error) {
          showMessage("Campos incompletos", "error");
        });
    } else {
      if (manodeobra.mo_nombre === "") {
        seterror((error) => {
          return { ...error, mo_nombre: "Campo requerido" };
        });
      }

      if (manodeobra.mo_descripcion === "") {
        seterror((error) => {
          return { ...error, mo_descripcion: "Campo requerido" };
        });
      }

      if (manodeobra.mo_precio === "") {
        seterror((error) => {
          return { ...error, mo_precio: "Campo requerido" };
        });
      }

      showMessage("Campos incompletos", "error");
    }
  };

  const updatemanodeobra = async () => {
    seterror((error) => {
      return {
        ...error,
        mo_nombre: "",
        mo_descripcion: "",
        mo_precio: "",
      };
    });

    if (
      manodeobra.mo_nombre !== "" &&
      manodeobra.mo_descripcion !== "" &&
      manodeobra.mo_precio !== ""
    ) {
      setisLoadingmanodeobraCreada("visible");
      await axios

        .post(server + "taller/updateManoObra", {
          mo_id: manodeobra.mo_id,
          mo_nombre: manodeobra.mo_nombre,
          mo_descripcion: manodeobra.mo_descripcion,
          mo_precio: parseFloat(manodeobra.mo_precio),
        })

        .then(function (response) {
          setisLoadingmanodeobraCreada("invisible");

          if (response.status === 200) {
            showMessage("Mano de Obra actualizada con éxito", "success");

            setmanodeobra((manodeobra) => {
              return {
                ...manodeobra,
                mo_id: 0,
                mo_nombre: "",
                mo_descripcion: "",
                mo_precio: "",
              };
            });

            setshowModal(false);

            getmanodeobras();
          } else {
            showMessage("Error el crear", "error");
          }
        })
        .catch(function (error) {
          showMessage("Campos incompletos", "error");
        });
    } else {
      if (manodeobra.mo_nombre === "") {
        seterror((error) => {
          return { ...error, mo_nombre: "Campo requerido" };
        });
      }

      if (manodeobra.mo_descripcion === "") {
        seterror((error) => {
          return { ...error, mo_descripcion: "Campo requerido" };
        });
      }

      if (manodeobra.mo_precio === "") {
        seterror((error) => {
          return { ...error, mo_precio: "Campo requerido" };
        });
      }

      showMessage("Campos incompletos", "error");
    }
  };

  useEffect(() => {
    const getmanodeobrasInicial = async () => {
      setisLoadingTable("visible");
      await axios
        .get(server + "taller/getManoObra")
        .then(function (response) {
          setisLoadingTable("invisible");
          setdataTable(response.data);
        })
        .catch(function (error) {
          setisLoadingTable("invisible");
        })
        .then(function () {});
    };

    getmanodeobrasInicial();
  }, [server]);

  return (
    <Fragment>
      <ReactCSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}
      >
        <div>
          <PageTitle heading="Mano de Obra" icon="pe-7s-like2" />
          {/* <Container fluid={true} className="content-body"> */}
          <Row>
            <Col md="12" lg="12">
              <div>
                <Card>
                  <div className="text-center">
                    <div
                      className={isLoadingmanodeobraCreada}
                      style={{ marginTop: 10 }}
                    >
                      <Spinner
                        animation="border"
                        role="status"
                        variant="secondary"
                      ></Spinner>
                    </div>
                  </div>

                  <Card.Header as="h5">
                    Creación de Nueva Mano de Obra{" "}
                  </Card.Header>
                  <Card.Body>
                    <Form>
                      <FormGroup as={Row}>
                        <Col>
                          <Form.Label className="title-create">
                            Nombre:{" "}
                          </Form.Label>
                          <Form.Control
                            maxLength={50}
                            placeholder="Ingrese un Nombre"
                            id="mo_nombre"
                            value={manodeobra.mo_nombre}
                            onChange={(e) => {
                              const val = e.target.value;
                              setmanodeobra((manodeobra) => {
                                return { ...manodeobra, mo_nombre: val };
                              });
                            }}
                          />
                          <span style={{ color: "red" }}>
                            {error.mo_nombre}
                          </span>
                        </Col>

                        <Col>
                          <Form.Label className="title-create">
                            Precio:{" "}
                          </Form.Label>
                          <Form.Control
                            maxLength={50}
                            placeholder="Ingrese un Precio"
                            id="mo_precio"
                            value={manodeobra.mo_precio}
                            onChange={(e) => {
                              const val = e.target.value;
                              setmanodeobra((manodeobra) => {
                                return { ...manodeobra, mo_precio: val };
                              });
                            }}
                          />
                          <span style={{ color: "red" }}>
                            {error.mo_precio}
                          </span>
                        </Col>
                      </FormGroup>

                      <FormGroup as={Row}>
                        <Col>
                          <Form.Label className="title-create">
                            Descripción:{" "}
                          </Form.Label>
                          <Form.Control
                            maxLength={50}
                            placeholder="Ingrese una Descripción"
                            id="mo_descripcion"
                            value={manodeobra.mo_descripcion}
                            onChange={(e) => {
                              const val = e.target.value;
                              setmanodeobra((manodeobra) => {
                                return { ...manodeobra, mo_descripcion: val };
                              });
                            }}
                          />
                          <span style={{ color: "red" }}>
                            {error.mo_descripcion}
                          </span>
                        </Col>
                      </FormGroup>

                      <div className="text-center">
                        <Button
                          onClick={() => {
                            createmanodeobra();
                          }}
                          variant="primary"
                        >
                          Crear una Mano de Obra
                        </Button>
                      </div>
                    </Form>
                  </Card.Body>
                </Card>
              </div>
              <div>
                <Card className="mt-2">
                  <Card.Header as="h5">
                    Listado general de "mano de obra"
                  </Card.Header>
                  <Card.Body>
                    <BootstrapTable
                      keyField="mo_id"
                      wrapperClasses="table-responsive"
                      data={dataTable}
                      columns={columns}
                      pagination={paginationFactory()}
                    />

                    <div className="text-center">
                      <div className={isLoadingTable} style={{ marginTop: 10 }}>
                        <Spinner
                          animation="border"
                          role="status"
                          variant="secondary"
                        ></Spinner>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>

              <div>
                <Modal
                  show={showModal}
                  // onHide={!showModal}
                  size="lg"
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                >
                  <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                      Actualización de datos de: {manodeobra.mo_nombre}
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="text-center">
                      <div className={isLoadingActualizar}>
                        <Spinner
                          animation="border"
                          role="status"
                          variant="secondary"
                        ></Spinner>
                      </div>
                    </div>

                    <div style={{ marginTop: 10 }}>
                      <Form>
                        <FormGroup as={Row}>
                          <Col>
                            <Form.Label className="title-create">
                              Nombre:{" "}
                            </Form.Label>
                            <Form.Control
                              maxLength={50}
                              placeholder="Ingrese un Nombre"
                              id="mo_nombre"
                              value={manodeobra.mo_nombre}
                              onChange={(e) => {
                                const val = e.target.value;
                                setmanodeobra((manodeobra) => {
                                  return { ...manodeobra, mo_nombre: val };
                                });
                              }}
                            />
                            <span style={{ color: "red" }}>
                              {error.mo_nombre}
                            </span>
                          </Col>

                          <Col>
                            <Form.Label className="title-create">
                              Precio:{" "}
                            </Form.Label>
                            <Form.Control
                              maxLength={50}
                              placeholder="Ingrese un Precio"
                              id="mo_precio"
                              value={manodeobra.mo_precio}
                              onChange={(e) => {
                                const val = e.target.value;
                                setmanodeobra((manodeobra) => {
                                  return { ...manodeobra, mo_precio: val };
                                });
                              }}
                            />
                            <span style={{ color: "red" }}>
                              {error.mo_precio}
                            </span>
                          </Col>
                        </FormGroup>

                        <FormGroup as={Row}>
                          <Col>
                            <Form.Label className="title-create">
                              Descripción:{" "}
                            </Form.Label>
                            <Form.Control
                              maxLength={50}
                              placeholder="Ingrese una Descripción"
                              id="mo_descripcion"
                              value={manodeobra.mo_descripcion}
                              onChange={(e) => {
                                const val = e.target.value;
                                setmanodeobra((manodeobra) => {
                                  return { ...manodeobra, mo_descripcion: val };
                                });
                              }}
                            />
                            <span style={{ color: "red" }}>
                              {error.mo_descripcion}
                            </span>
                          </Col>
                        </FormGroup>
                      </Form>
                    </div>
                  </Modal.Body>

                  <Modal.Footer>
                    <Button
                      onClick={() => {
                        updatemanodeobra();
                      }}
                    >
                      Actualizar
                    </Button>
                    <Button
                      onClick={() => {
                        setshowModal(false);

                        seterror((error) => {
                          return {
                            ...error,
                            mo_nombre: "",
                            mo_descripcion: "",
                            mo_precio: "",
                          };
                        });

                        setmanodeobra((manodeobra) => {
                          return {
                            ...manodeobra,
                            mo_id: 0,
                            mo_nombre: "",
                            mo_descripcion: "",
                            mo_precio: "",
                          };
                        });
                      }}
                    >
                      Cerrar
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>
            </Col>
          </Row>
          {/* </Container> */}
        </div>
      </ReactCSSTransitionGroup>
    </Fragment>
  );
}

export default Content;
